/**
 * Display-only normalize for Drive sync conflict diffs.
 * Mirrors scripts/services/google-drive-sync.js normalizeForDriveCompare.
 * Keep / Use Google Drive still apply raw bodies from the sync hook.
 * Drive conflict visual: original = Drive (left), proposed = Maater (right).
 */

function normalizeDriveBody(markdown: string): string {
  const raw = String(markdown || '')
  const stripped = raw.replace(/^---\r?\n[\s\S]*?\r?\n---\r?\n?/, '').trim()
  return stripped
    .replace(/\r\n/g, '\n')
    .replace(/ {2}\n\n/g, '  \n')
    .replace(/\n+$/, '')
}

function extractLogicalLines(markdown: string): string[] {
  const body = normalizeDriveBody(markdown)
  if (!body) return []
  return body
    .split(/\n{2,}| {2}\n/)
    .map((line) => line.replace(/[ \t]+$/g, '').trim())
    .filter((line) => line.length > 0)
}

function normalizeDriveCompareLine(line: string): string {
  let l = String(line || '')
    .replace(/[ \t]+$/g, '')
    .trim()
  if (!l) return ''
  l = l.replace(/^(?:>\s*)+/, '')
  if (/^[*+-]\s+/.test(l)) {
    l = `- ${l.replace(/^[*+-]\s+/, '').trim()}`
  }
  return l.replace(/[ \t]{2,}/g, ' ').trim()
}

/** Semantic body for quieter Drive conflict diffs (formatting churn suppressed). */
export function normalizeForDriveCompare(markdown: string): string {
  return extractLogicalLines(markdown)
    .map(normalizeDriveCompareLine)
    .filter((line) => line.length > 0)
    .join('\n')
}
